import React from 'react';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import Element, { ElementDropPreview } from './Element';
import { DropTarget } from 'react-dnd';
import Highlightable from '../HOCs/Highlightable';
import flow from 'lodash.flow';
import findIndex from 'lodash.findindex';
import { distance } from '../util';
import { ItemTypes } from '../constants';

import {
  insertElementIntoColumn,
  removeElementFromColumn,
  setDropPreviewIndexPath,
  resetDropPreviewIndexPath,
  reindexElements
} from '../actions/column-actions';

import styles from '../../../../stylesheet/css/header-builder/column.css';

const findClosestElement = (elementRefs, clientOffset) => {
  const ids = Object.keys(elementRefs),
        elementsInfo = ids.map(id => ({
          id: parseInt(id),
          index: elementRefs[id].index,
          rect: elementRefs[id].el.getBoundingClientRect()
        }));

  let closestElementInfo = elementsInfo[0],
      minDistance = Infinity;

  return elementsInfo.reduce((closest, elInfo) => {
    const elemRect = elInfo.rect,
          elemRectCenterX = (elemRect.right + elemRect.left) / 2,
          elemRectCenterY = (elemRect.bottom + elemRect.top) / 2,
          d = distance(elemRectCenterX, elemRectCenterY, clientOffset.x, clientOffset.y);

    if (d < minDistance) {
      minDistance = d;
      return elInfo;
    }

    return closest;
  }, closestElementInfo);
};

const target = {
  drop(props, monitor) {
    const item = monitor.getItem(),
          { device, rowId, id, dropPreviewIndex, elements, onDrop, onReindexElements } = props,
          itemIndex = findIndex(elements, el => el.id === item.id),
          sourceIndex = itemIndex,
          targetIndex = dropPreviewIndex > itemIndex ? dropPreviewIndex - 1 : dropPreviewIndex;

    if (itemIndex < 0) {
      onDrop(device, rowId, id, dropPreviewIndex, item);
    } else if (targetIndex !== null) {
      onReindexElements(device, rowId, id, sourceIndex, targetIndex);
    }

    return { droppedToTheSameColumn: itemIndex >= 0 };
  },

  hover(props, monitor, component) {
    const movementThreshold = 40,
          elementRefs = component.elementRefs,
          clientOffset = monitor.getClientOffset(),
          item = monitor.getItem();

    const movedEnough = () => {
      const o1 = component.lastClientOffset,
            o2 = clientOffset;
      return distance(o1.x, o1.y, o2.x, o2.y) > movementThreshold;
    };

    if (!elementRefs || elementRefs.length === 0 || (component.lastClientOffset && !movedEnough())) {
      return;
    }

    component.lastClientOffset = clientOffset;

    const closestElementInfo = findClosestElement(elementRefs, clientOffset);

    if (!closestElementInfo) {
      return;
    }

    const { id, onDropPreview, onResetDropPreview } = props;
    let index = closestElementInfo.index;

    if (clientOffset.x > (closestElementInfo.rect.right + closestElementInfo.rect.left) / 2) {
      index++;
    }

    if (elementRefs[item.id]) {
      const itemIndex = elementRefs[item.id].index;

      if ((index > itemIndex ? index - 1 : index) === itemIndex) {
        onResetDropPreview(id);
        return;
      }
    }

    onDropPreview(id, index);
  }
};

function collect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    canDrop: monitor.canDrop(),
    isOver: monitor.isOver()
  };
}

let Column = React.createClass({
  componentWillReceiveProps(nextProps) {
    if (this.props.isOver && !nextProps.isOver) {
      const { device, rowId, id } = this.props;
      this.props.onResetDropPreview(device, rowId, id);
    }
  },

  onElementRef(id, index, ref) {
    if (ref === null) {
      delete this.elementRefs[id];
      return;
    }

    const el = ReactDOM.findDOMNode(ref);

    if (!this.elementRefs) {
      this.elementRefs = {};
    }

    this.elementRefs[id] = { el, index };
  },

  renderElements() {
    const {
      device,
      rowId,
      id,
      width,
      elements,
      dropPreviewIndex,
      onRemoveElement
    } = this.props;

    if (elements.length) {
      let arr = elements.map((element, index) => {
        let result = [];

        if (dropPreviewIndex === index) {
          result.push(<ElementDropPreview key={'drop-preview'} />);
        }

        result.push(<Element
          key={element.id}
          device={device}
          ref={this.onElementRef.bind(this, element.id, index)}
          onRemove={onRemoveElement.bind(null, device, rowId, id)}
          {...element}
        />);

        return result;
      });

      if (dropPreviewIndex === elements.length) {
        arr.push(<ElementDropPreview key={'drop-preview'} />);
      }

      return arr;
    } else {
      //return <span>{width}</span>;
    }
  },

  onMouseOver(e) {
    this.columnNode = e.target;
    this.columnNode.classList.add(styles.columnLabel);
  },

  onMouseOut(e) {
    this.columnNode.classList.remove(styles.columnLabel);
  },

  render() {
    const {
      options = {},
      connectDropTarget,
      canDrop,
      isOver,
      isHighlighted,
      onHighlight,
      width
    } = this.props;

    let className = styles.column;

    if (canDrop && isOver) {
      className += ' ' + styles.canDrop;
    }

    if (isHighlighted) {
      className += ' ' + styles.highlighted;
    }

    if (width === 0) {
      return null;
    }

    return connectDropTarget(
      <td
        colSpan={width}
        className={className}
        onClick={onHighlight}
        onMouseOver={this.onMouseOver}
        onMouseOut={this.onMouseOut}>
        <span className={styles.label}>Col {width}</span>
        {this.renderElements()}
      </td>
    );
  }
});

Column = flow(
  DropTarget(ItemTypes.ELEMENT, target, collect),
  Highlightable()
)(Column);

export { Column };

const mapStateToProps = (state, ownProps) => {
  const path = state.viewModel.dropPreviewIndexPath;
  let dropPreviewIndex = null;

  if (path !== null && path.columnId === ownProps.id) {
    dropPreviewIndex = path.index;
  }

  return {
    dropPreviewIndex
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onDrop(device, rowId, columnId, index, item) {
      dispatch(insertElementIntoColumn({ device, rowId, columnId, index, element: item }));
    },

    onReindexElements(device, rowId, columnId, sourceIndex, targetIndex) {
      dispatch(reindexElements({ device, rowId, columnId, sourceIndex, targetIndex }));
    },

    onRemoveElement(device, rowId, columnId, id) {
      dispatch(removeElementFromColumn({ device, rowId, columnId, id }));
    },

    onDropPreview(columnId, index) {
      dispatch(setDropPreviewIndexPath({ columnId, index }));
    },

    onResetDropPreview(columnId) {
      dispatch(resetDropPreviewIndexPath({ columnId }));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Column);



// WEBPACK FOOTER //
// ./app/header-builder/components/Column.js